import { ENodeInputTypeCode, ENodeOutputTypeCode, INodeInnerData } from '@shared/typings/flow/common/data';

export const isInputNodeByType = (nodeType: ENodeInputTypeCode | ENodeOutputTypeCode | undefined) =>
	/^10[\d]{2}$/.test(nodeType ?? '');

export const isOutputNodeByType = (
	nodeType: ENodeInputTypeCode | ENodeOutputTypeCode | undefined,
) => /^20[\d]{2}$/.test(nodeType ?? '');


export const isInnerImage = (
	data: INodeInnerData.UnionInput | INodeInnerData.UnionOutput,
): data is INodeInnerData.OutputImage | INodeInnerData.InputImage => {
	return data.type === '10';
};

export const isInnerText = (
	data: INodeInnerData.UnionInput | INodeInnerData.UnionOutput,
): data is INodeInnerData.InputText | INodeInnerData.OutputText => {
	return data.type === '20';
};

export const isInnerVideo = (data: INodeInnerData.UnionInput | INodeInnerData.UnionOutput) : data is INodeInnerData.OutputVideo => {
	return data.type === '30';
}